import { useAppUserAccess } from 'global/cnr/contexts/useHelpers/useAppUserAccess';
import React from 'react'
import { Button, Modal } from 'semantic-ui-react';

export const ModalPopup = ({ text, handleClose, handleSignIn }) => {

  const appUserAccess = useAppUserAccess()
  const { loggedIn, isAdminOrSuper } = appUserAccess ?? {}
  console.log('appUserAccess', appUserAccess)

  return <Modal
    size={'mini'}
    open={true}
    onClose={() => handleClose({ type: 'close' })}
    className={'mdl app-dark-mode'}
  >
    <Modal.Header>Score Reporting</Modal.Header>
    <Modal.Content >
      <div style={{ display: 'flex', flexDirection: 'column', rowGap: '.5em' }}>
        <div>Via App:</div>
        <div style={{ lineHeight: '1.6' }} dangerouslySetInnerHTML={{ __html: text }} />
      </div>
    </Modal.Content>

    <Modal.Content >
      <div style={{ display: 'flex', flexDirection: 'column', rowGap: '.5em' }}>
        <div>Via Email:</div>
        <div
          className='highlight score'
          style={{ cursor: 'pointer' }}
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            const email = 'thumbstatsports@gmail.com';
            window.open(
              `https://mail.google.com/mail/?view=cm&fs=1&to=${encodeURIComponent(email)}`,
              '_blank'
            );
          }}
        >
          thumbstatsports@gmail.com
        </div>
      </div>
    </Modal.Content>
    <Modal.Actions>
      {loggedIn && <Button style={{ float: 'left' }} color='blue' size='tiny' onClick={() => handleSignIn()}>
        Sign In
      </Button>}
      <Button color='blue' size='tiny' onClick={() => handleClose({ type: 'close' })}>
        OK
      </Button>
    </Modal.Actions>
  </Modal>
}
